export default "__VITE_PUBLIC_ASSET__545998ce__"